module.exports = __webpack_public_path__ + "img/logo_text.215559c8.png";